import React from 'react';
import IsoDatePicker from './IsoDatePicker';

// TimeFiltersBar.jsx
export default function TimeFiltersBar({
  draft,
  setDraft,
  onApply,
  bookingRange,
  includeDates
}) {
  const showRoomsExact =
    (!!draft.day_from || !!draft.day_to) &&
    (draft.category === '' || draft.category === 'rooms');
  const onChangeFromTime = (e) => setDraft({ ...draft, win_start: e.target.value || '' });
  const onChangeToTime   = (e) => setDraft({ ...draft, win_end:   e.target.value || '' });

  function setFromDay(iso) {
    const from = iso || null;
    let to = draft.day_to || null;
    // keep day_to >= day_from (or empty)
    if (from && to && to < from) to = from;
    setDraft({ ...draft, day_from: from, day_to: to });
  }
  function setToDay(iso) {
    const to = iso || null;
    let from = draft.day_from || null;
    // if no from yet, set from = to for convenience
    if (!from && to) from = to;
    // keep day_to >= day_from
    const next = (from && to && to < from) ? from : to;
    setDraft({ ...draft, day_from: from, day_to: next });
  }
  return (
    <div className="flex flex-wrap items-end gap-3">
      <div>
        <label className="block text-xs text-gray-600">From</label>
        <IsoDatePicker
          value={draft.day_from || ''}
          onChange={setFromDay}
          minDate={bookingRange?.start_date}
          maxDate={bookingRange?.end_date}
          includeDates={includeDates}
          includeDatesStrict={!!(includeDates && includeDates.length)}
        />
      </div>
      <div>
        <label className="block text-xs text-gray-600">To</label>
        <IsoDatePicker
          value={draft.day_to || ''}
          onChange={setToDay}
          minDate={draft.day_from || bookingRange?.start_date}
          maxDate={bookingRange?.end_date}
          includeDates={includeDates}
          includeDatesStrict={!!(includeDates && includeDates.length)}
        />
      </div>
      <div>
        <label className="block text-xs text-gray-600">From</label>
        <input
          type="time"
          step={900}
          value={draft.win_start || ''}
          onChange={onChangeFromTime}
          className="border rounded px-2 py-1 w-28"
        />
      </div>

      <div>
        <label className="block text-xs text-gray-600">To</label>
        <input
          type="time"
          step={900}
          value={draft.win_end || ''}
          onChange={onChangeToTime}
          className="border rounded px-2 py-1 w-28"
        />
      </div>

      <div>
        <label className="block text-xs text-gray-600">Party</label>
        <input
          type="number"
          min={1}
          value={draft.party}
          onChange={e => setDraft({ ...draft, party: Number(e.target.value || 1) })}
          className="border rounded px-2 py-1 w-24"
        />
      </div>
      {/* Category (small dropdown) */}
      <div>
        <label className="block text-xs text-gray-600">Category</label>
        <select
          value={draft.category || ''}
          onChange={e => setDraft({ ...draft, category: e.target.value })}
          className="border rounded px-2 py-1 w-40"
        >
          <option value="">All</option>
          <option value="services">Services</option>
          <option value="classes">Classes</option>
          <option value="tables">Tables</option>
          <option value="rooms">Rooms</option>
          <option value="bundles">Bundles</option>
        </select>
      </div>

      {/* Rooms exact dates vs flexible */}
      {showRoomsExact && (
        <label className="inline-flex items-center gap-2 ml-2">
          <input
            type="checkbox"
            checked={!!draft.ac_exact}
            onChange={e => setDraft({ ...draft, ac_exact: e.target.checked })}
          />
          <span className="text-sm">Rooms: require exact dates</span>
        </label>
      )}
      <button
        onClick={onApply}
        className="ml-auto px-4 py-2 rounded bg-black text-white text-sm"
      >
        Apply
      </button>
    </div>
  );
}
